import { Grid } from '@chakra-ui/react';
import { PLATFORM_OPTIONS } from '~/screens/MyAgency/components/PlatformsToggle';
import { SelectButton } from '~/screens/MyAgency/components/utils';
import { useAdvancedFiltersStore } from '~/screens/MyAgency/store';
import {
  FILTERS,
  IGAge,
  TikTokAge,
  YouTubeAge,
} from '~/screens/MyAgency/types';
import { convertPxToRems } from '~/utils-ts';

const agesInstagram = ['13-17', '18-24', '25-34', '35-44', '45-64', '65+'];
const agesTiktok = ['18-24', '25-34', '35+'];
const agesYoutube = [
  '13-17',
  '18-24',
  '25-34',
  '35-44',
  '45-54',
  '55-64',
  '65+',
];

const agesSnapchat = ['13-17', '18-20', '21-24', '25-34', '35+'];

const AgesMap = {
  [PLATFORM_OPTIONS.selectPlatform]: agesInstagram,
  [PLATFORM_OPTIONS.instagram]: agesInstagram,
  [PLATFORM_OPTIONS.tiktok]: agesTiktok,
  [PLATFORM_OPTIONS.youtube]: agesYoutube,
  [PLATFORM_OPTIONS.snapchat]: agesSnapchat,
};

export const AgeInputFilter: React.FC = () => {
  const { activePlatform, getFilter, setFilter } = useAdvancedFiltersStore();

  const ageValueInURL = getFilter(activePlatform, FILTERS.age);

  return (
    <Grid
      templateColumns={`repeat(${AgesMap[activePlatform].length}, 1fr)`}
      gap="4px"
      marginTop={convertPxToRems(16)}
    >
      {AgesMap[activePlatform].map((age) => (
        <SelectButton
          key={age}
          value={age}
          isSelected={ageValueInURL === age}
          isDisabled={
            (activePlatform as string) === PLATFORM_OPTIONS.selectPlatform
          }
          onSelect={(value: IGAge | TikTokAge | YouTubeAge) =>
            setFilter(activePlatform, FILTERS.age, value)
          }
        />
      ))}
    </Grid>
  );
};
